import React from 'react';
import { OverlayLoader } from './LoadingSpinner';

// Full-page overlay loader to ensure visibility during lazy loads
const AppLoader = ({ text = 'Cargando...' }) => {
  return (
    <OverlayLoader text={text} />
  );
};

export default AppLoader;